import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getAllExpense } from '../../targetactioncreator';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Loader from '../../../../../presentationals/Loader/Loader.component';
import CategoryMain from './CategoryMain';
import AddExpense from '../expenseaddnew'
import ProvisionMain from '../Provision/main'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../../../reducers/CommonFilters.reducer';

const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

const ExpenseDashboard = ({ admin }) => {
    const dispatch = useDispatch();
    const { fromDate: ReducerFrom, toDate: ReducerTo } = useSelector(state => state.FilterReduce.commonFilters);
    const [loader, setLoader] = useState(false)
    const [editData, seteditData] = useState({})

    const [expenseData, setExpenseData] = useState({


    });

    const [graphData, setgraphData] = useState({})
    const [chartSeries, setchartSeries] = useState([])
    const [chartLabels, setchartLabels] = useState([])

    const [startDate, setStartDate] = useState(ReducerFrom);
    const [endDate, setEndDate] = useState(ReducerTo);
    const [selectedData, setSelectedData] = useState({});
    const [categoryOverviewScreen, setcategoryOverviewScreen] = useState(false)
    const [viewType, setviewType] = useState('list')

    useEffect(() => {
        setStartDate(ReducerFrom)
        setEndDate(ReducerTo)
        getExpenseData(ReducerFrom, ReducerTo)
    }, [ReducerFrom, ReducerTo]);
    useEffect(() => {
        if (viewType === "list") {
            getExpenseData(InitalDate('fromDate'), InitalDate('toDate'))
        }
    }, [viewType]);

    const getExpenseData = (fromDate, toDate) => {
        const start = moment(fromDate).format('DD-MM-YYYY')
        const end = moment(toDate).format('DD-MM-YYYY')
        setLoader(true)
        getAllExpense(start, end, callback => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                const data = callback?.data?.graphData || {};
                setchartSeries(Object.values(data).map(item => item?.expenseAmount || 0));
                setchartLabels(Object.keys(data));
                setExpenseData(callback?.data);
                setgraphData(data);
            } else {
                setExpenseData({});
                setgraphData({});
                setchartSeries([])
                setchartLabels([]);
            }
            setLoader(false)
        });
    }




    const chartColors = [
        '#80b7f7',
        '#77FF8F',
        '#FF8F73',
        '#F1C54C',
        '#9B5FBD',
        '#7EC2E0',
        '#76F19E',
        '#F1988D',
        '#BB7FE2',
        '#607A82'
    ];

    const chartOptions = {
        chart: {
            type: 'donut',
        },
        labels: chartLabels,
        colors: chartColors,
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: true,
            formatter: (val, opts) => {
                // Show raw values from the series
                const index = opts.seriesIndex;
                return chartSeries[index];
            },
        },
        tooltip: {
            y: {
                formatter: (val) => val, // Show raw values in the tooltip
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom',
                }
            }
        }],
    };

    const handleClick = () => {
        getExpenseData(startDate, endDate)
    }

    const handleCategoryData = (category) => {
        setSelectedData(graphData[category])
        setcategoryOverviewScreen(true)
    }

    const handleBack = () => {
        setSelectedData({})
        setcategoryOverviewScreen(false)
    }

    return (
        <div className="NewExpenseManagementCSS MainDashboard">
            {
                loader ? <Loader /> : ''
            }
            {viewType === 'add' || viewType === "addProvision" ?
                <button className='btn btn-primary' onClick={() => setviewType('list')}>Back</button>
                : ""}
            {viewType === 'list' ?
                <>
                    {/* {!categoryOverviewScreen? 
               <div className='d-flex'>
                   <button className='btn btn-primary' style={{marginRight:'10px'}} onClick={()=>setviewType('add')}><i className='fa fa-add'></i>Add Expense</button>
                   <button className='btn btn-primary' onClick={()=>setviewType('addProvision')}><i className='fa fa-add'></i>Add Provision</button>
               </div>
               :""} */}
                    {
                        categoryOverviewScreen ?
                            <CategoryMain selectedData={selectedData} startDate={startDate} endDate={endDate} handleBack={handleBack} admin={admin} />
                            :
                            <div className='container-fluid'>
                                <div className='row' style={{ marginBottom: '30px' }}>
                                    <div className='col-sm-12 col-xs-12' style={{ marginTop: '20px' }}>
                                        <div className='datePickercss'>
                                            <div className="row">

                                                <div className="col-sm-2 col-xs-12">

                                                    <label>Start Date</label>
                                                    <input type="date" id='customDateInput' className='form-control' value={startDate} onChange={(e) => {setStartDate(e.target.value);dispatch({ type: FILTER_ACTION, payload: { fromDate: e.target.value } });}} />

                                                </div>
                                                <div className="col-sm-2 col-xs-12">
                                                    <label>End Date</label>
                                                    <input type="date" id='customDateInput' className='form-control' value={endDate} onChange={(e) => {setEndDate(e.target.value);dispatch({ type: FILTER_ACTION, payload: { toDate: e.target.value } });}} />

                                                </div>
                                                <div className="col-sm-2 col-xs-12">
                                                    <button className='btn btn-primary' onClick={() => handleClick()} style={{ padding: '10px', marginTop: '22px' }}>Apply Filter</button>
                                                </div>
                                                <div className="col-sm-3 col-xs-12" style={{ float: 'right' }}>
                                                    <div style={{ display: 'flex', marginTop: '22px', justifyContent: 'end' }}>
                                                        <button className='btn btn-primary' style={{ marginRight: '10px', padding: '10px' }} onClick={() => setviewType('add')}><i className='fa fa-add'></i>Add Expense</button>
                                                        <button className='btn btn-primary' onClick={() => setviewType('addProvision')} style={{ padding: '10px' }}><i className='fa fa-add'></i>Add Provision</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className='row'>

                                    <div className='col-sm-3 col-xs-12'>
                                        <div className='shadow-cardss' style={{ marginBottom: '20px', padding: '20px', borderRadius: '10px', background: '#FCEED1', boxShadow: '4px 4px 0px 2px rgb(252 178 65 / 60%)' }}>
                                            <h4 className="cardh4"><b>{(expenseData?.calculation?.expenseTarget || 0)?.toLocaleString("en-US")}</b></h4>
                                            <label className="cardLabel">Expense Target</label>
                                        </div>
                                    </div>
                                    <div className='col-sm-3 col-xs-12'>
                                        <div className='shadow-cardss' style={{ marginBottom: '20px', padding: '20px', borderRadius: '10px', background: '#FFE5E5', boxShadow: '4px 4px 0px 2px rgba(255, 99, 99, 0.6)' }}>
                                            <h4 className="cardh4"><b>{(expenseData?.calculation?.expense || 0)?.toLocaleString("en-US")}</b></h4>
                                            <label className="cardLabel">Expense</label>
                                        </div>
                                    </div>
                                    <div className='col-sm-3 col-xs-12'>
                                        <div className='shadow-cardss' style={{ marginBottom: '20px', padding: '20px', borderRadius: '10px', background: '#E2F7E1', boxShadow: '4px 4px 0px 2px rgba(72, 199, 142, 0.6)' }}>
                                            <h4 className="cardh4"><b>{(expenseData?.calculation?.balance || 0)?.toLocaleString("en-US")}</b></h4>
                                            <label className="cardLabel">Balance</label>
                                        </div>
                                    </div>
                                    <div className='col-sm-3 col-xs-12'>
                                        <div className='shadow-cardss' style={{ marginBottom: '20px', padding: '20px', borderRadius: '10px', background: '#E5EFFF', boxShadow: '4px 4px 0px 2px rgba(72, 149, 239, 0.6)' }}>
                                            <h4 className="cardh4"><b>{(expenseData?.calculation?.noOfTransaction || 0)?.toLocaleString("en-US")}</b></h4>
                                            <label className="cardLabel">Transactions</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='shadow-card' style={{ marginTop: '20px' }}>
                                    <div className='row'>

                                        <div className='col-sm-6 col-xs-12' style={{ marginTop: '30px' }}>
                                            <div style={{ minHeight: '450px' }}>
                                                <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={400} width="100%" />
                                            </div>
                                        </div>
                                        <div className='col-sm-6 col-xs-12' style={{ marginTop: '30px' }}>
                                            <div style={{ minHeight: '450px' }}>
                                                <ul>
                                                    {Object.keys(graphData).map((category, index) => (
                                                        <div key={index} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                            <div style={{ width: '30%', display: 'flex' }}>
                                                                <span
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: chartColors[index % chartColors.length],
                                                                        marginRight: '10px',
                                                                        marginTop: '10px'
                                                                    }}
                                                                ></span>
                                                                <div style={{ marginTop: '10px', cursor: 'pointer' }} onClick={() => handleCategoryData(category)}>{category}</div>
                                                            </div>
                                                            <div style={{ width: '50%', paddingTop: '8px' }}>
                                                                <div style={{ marginLeft: '20px' }}>
                                                                    {(graphData[category]?.expenseAmount)?.toLocaleString("en-US") || 0} &nbsp;&nbsp; {graphData[category]?.percentage || 0}%
                                                                </div>

                                                            </div>
                                                        </div>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </> : ""}
            {viewType === 'add' ?
                <AddExpense setViewType={setviewType} admin={admin} editData={editData} />
                : ""}
            {
                viewType === "addProvision" ?
                    <ProvisionMain setViewType={setviewType} admin={admin} />
                    : ""}
        </div>
    );
};

export default ExpenseDashboard;
